import {
  StyledButton,
  SubmitButtonContainer,
  TypoBodyLagre
} from "@/components/commons/customStyles";
import { ColorConf } from "@/config/color";
import { RootContext } from "@/contexts/rootContext";
import { NAVBAR_LINK } from "@/utils/enum";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Box } from "@mui/material";
import Image from "next/image";
import Link from "next/link";
import { useContext, useMemo } from "react";

export default function NotFound() {
  const { state } = useContext(RootContext);

  const link = useMemo(() => {
    return state?.isLoggedIn ? NAVBAR_LINK.home : NAVBAR_LINK.defaultPage;
  }, [state?.isLoggedIn]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh"
      }}
    >
      <Image
        src={"/images/404.svg"}
        alt="404"
        width={0}
        height={0}
        sizes="100vw"
        priority={true}
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "16px 16px 0 0",
          maxHeight: "300px"
        }}
      />
      <TypoBodyLagre
        sx={{
          color: ColorConf.MonoSecondaryText,
          fontWeight: 600,
          paddingTop: 3
        }}
      >
        ページが見つかりません
      </TypoBodyLagre>
      <Link href={link}>
        <SubmitButtonContainer width={1} mt={2}>
          <StyledButton
            variant="contained"
            color="primary"
            type="button"
            startIcon={<HomeOutlinedIcon />}
          >
            ホームに戻る
          </StyledButton>
        </SubmitButtonContainer>
      </Link>
    </Box>
  );
}
